import axios from "axios";
import { CreateTaskPayload, CreateTaskResponse, AddCommentPayload, AddCommentResponse } from "../interfaces/omuni";
import {
    createTaskRequest,
    createTaskSuccess,
    createTaskFailure,
    addCommentRequest,
    addCommentSuccess,
    addCommentFailure,
} from "../reducers/omuni";

const OMUNI_BASE_URL = process.env.REACT_APP_OMUNI_URL || "https://omuni-integrations-stag-slzof6my2a-uc.a.run.app";
const OMUNI_API_KEY = process.env.REACT_APP_OMUNI_API_KEY || "YXBpa2V5MUA2MjlhNzFkM2FmNzEzYzhlMzE5Y2Y5MDY6cncwQmxDQXQ=";

const omuniHeaders = {
    'Content-Type': 'application/json',
    'token': OMUNI_API_KEY,
    'user-agent': 'Denwa UC',
};

export const createTask = (payload: CreateTaskPayload) => {
    return async (dispatch: any) => {
        dispatch(createTaskRequest());
        try {
            const response = await axios.post<CreateTaskResponse>(
                `${OMUNI_BASE_URL}/api/v1/integrations/task`,
                payload,
                { headers: omuniHeaders }
            );
            dispatch(createTaskSuccess(response.data.taskId));
            return response.data;
        } catch (error: any) {
            const errorMsg = error?.response?.data?.message || "Error al crear el caso";
            dispatch(createTaskFailure(errorMsg));
            throw error;
        }
    };
};

export const addComment = (taskId: string, payload: AddCommentPayload) => {
    return async (dispatch: any) => {
        dispatch(addCommentRequest());
        try {
            const response = await axios.post<AddCommentResponse>(
                `${OMUNI_BASE_URL}/api/v1/integrations/task/${taskId}/comments`,
                payload,
                { headers: omuniHeaders }
            );
            dispatch(addCommentSuccess());
            return response.data;
        } catch (error: any) {
            const errorMsg = error?.response?.data?.message || "Error al agregar comentario";
            dispatch(addCommentFailure(errorMsg));
            throw error;
        }
    };
};
